import { useState, useEffect } from 'react';

// Custom Hook
export const useTooltip = (delay: number = 300) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  // Handle mouse enter (start timer to show tooltip after delay)
  const handleMouseEnter = (): void => {
    const newTimer = setTimeout(() => {
      setShowTooltip(true);
    }, delay);
    setTimer(newTimer);
  };

  // Handle mouse leave (clear timer and hide tooltip)
  const handleMouseLeave = (): void => {
    if (timer) {
      clearTimeout(timer); // Clear the timeout
    }
    setShowTooltip(false); // Hide tooltip
  };

  // Cleanup the timer when the component unmounts
  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  return {
    showTooltip,
    setShowTooltip,
    handleMouseEnter,
    handleMouseLeave,
  };
};
